module.exports = __webpack_public_path__ + "img/company_kv_pc.a33f4b80.jpg";